var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"font-size-24 align-middle",class:[_vm.icon, _vm.color],attrs:{"title":_vm.text}}),(_vm.showText)?_c('span',{staticClass:"mr-1 ml-1"},[_vm._v(_vm._s(_vm.text))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }